import {Injectable} from "@angular/core";
import {CompleterService} from "ng2-completer";
import {GemeindeLocalData} from "../../shared/widgets/gb-gemeinde/GemeindeLocalData";
import {Observable} from "rxjs";

@Injectable()
export class AppGbgemeindeCompleterService extends CompleterService {

  gemeindeLocalData: GemeindeLocalData = new GemeindeLocalData();

  gemeindeLocal(data: any[] | Observable<any>, searchFields?: string | null, titleField?: string | null): GemeindeLocalData {
    return this.gemeindeLocalData.data(data).searchFields(searchFields).titleField(titleField);
  }
}
